export default __webpack_public_path__ + "static/media/gallery_00.ba58ce09.jpg";